<template>
<div>
    <b-card header-tag="header">
      <template #header>
        <div class="d-flex justify-content-between">
          <h4 class="mb-0 fw-bold">จำนวนพัสดุที่ตกค้าง</h4>
          <b-button pill variant="primary" size="sm" @click="onReload()" :disabled="busy">
            <i class="fas fa-sync-alt"></i>
          </b-button>
        </div>
      </template>
      <b-table
        responsive
        :items="items"
        :fields="fields"
        :busy="busy"
        head-variant="light"
      >
        <template #table-busy>
          <div class="d-flex align-items-center justify-content-center">
            <div class="circle-loading"></div>
            <span class="ml-2">กำลังโหลดข้อมูล...</span>
          </div>
        </template>
      </b-table>

      <div v-if="filters.courier_code === 'LZDS'" class="lazada-style">
        <div class="d-flex justify-content-between mt-5 p-2">
          <h4 class="mb-0 fw-bold">รายงาน Lazada Dropoff</h4>
        </div>
        
        <b-table 
          responsive
          :items="total_LZDS"
          :fields="fieldsLazada"
          :busy="busy"
          head-variant="light"
        >
          <template #table-busy>
            <div class="d-flex align-items-center justify-content-center">
              <div class="circle-loading"></div>
              <span class="ml-2">กำลังโหลดข้อมูล...</span>
            </div>
          </template>
        </b-table>
      </div>
    </b-card>
</div>
</template>
<script>
import columns from './js/columnsBacklog'
export default {
  props:{
    filters: Object,
    total_LZDS: [Object, Array],
  },
  data(){
    return {
      fieldsLazada: 
      [
        {
          key: 'courier',
          label: 'ขนส่ง',
        },
        {
          key: 'total',
          label: 'จำนวนพัสดุทั้งหมด',
          thClass: 'text-dark bg-primary',
          variant: 'primary'
        },
        {
          key: 'wait',
          label: 'รอเข้าระบบ'
        },
        {
          key: 'booking',
          label: 'รอเข้ารับ'
        },
        {
          key: 'complete',
          label: 'ขนส่งเข้ารับแล้ว'
        },
        // {
        //   key: 'cancel',
        //   label: 'ยกเลิก'
        // },
        // {
        //   key: 'invalid',
        //   label: 'เกิดข้อผิดพลาด'
        // }
      ],
      fields: columns,
      busy: true,
      itemsLazada: [
        {
          courier: 'LAZADA DROPOFF',
          total: 0,
          wait: 0,
          booking: 0,
          complete: 0,
          cancel: 0,
          invalid: 0,
        },
        {
          courier: 'KERRY DROPOFF',
          total: 0,
          wait: 0,
          booking: 0,
          complete: 0,
          cancel: 0,
          invalid: 0,
        },
        {
          courier: 'รวม',
          total: 0,
          wait: 0,
          booking: 0,
          complete: 0,
          cancel: 0,
          invalid: 0,
        }
      ],
      items: [
        { 
          total: 0,
          to_day: 0,
          yesterday: 0,
          two_days_ago: 0,
          three_days_ago: 0,
          more_than_four_days: 0
        }
      ]
    }
  },
  async mounted(){
    await this.backLogOrdersAPI()
  },
  methods:{
    onReload(){
      this.backLogOrdersAPI()
    },
    async backLogOrdersAPI(){
      this.isloading()
      const uri = '/shop/backlog/orders'
      const header = {
        headers: {
          Token: localStorage.getItem("access_token")
        }
      }
      const res = await this.$http.post( this.$API_URL + uri, {
            status_parcel: this.filters.status_parcel,
            courier_code: this.filters.courier_code,
            courier_tracking_code_prefix: this.filters.courier_code=='LZDS'?this.filters.courier_tracking_code_prefix:''
          }, header)
      try{
        let data = res.data
        if( data.status === true ){
          this.items = [data.data]
        }
      } catch ( e ){
        console.info( e )
      }
      this.isLoaded()
    },
    isloading(){
      this.busy = true
      return this.busy
    },
    isLoaded(){
      this.busy = false
      return this.busy
    }
  }
}
</script>

<style lang="scss" scoped>
.border-dropoff {
  border: 1px solid #cad1d7 !important; 
}
</style>